import { apiClient } from '@app/lib'
import { useSugarContext } from '@app/providers'
import { type SugarUnlockExpenditureResponse } from '@app/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useCompleteExpenditure = () => {
  const queryClient = useQueryClient()
  const sugar = useSugarContext()

  return useMutation({
    mutationKey: ['completeExpenditure'],
    mutationFn: async (expenditureId: string) => {
      const { data } = await apiClient.post<SugarUnlockExpenditureResponse>('/api/expenditures/complete', {
        expenditureId
      })

      return data
    },
    onSuccess: async (data) => {
      const { schoolYearId, quarterId, providerId } = data.data

      queryClient.setQueryData(
        ['expenditure', sugar?.isProviderRequired ? [schoolYearId, quarterId, providerId] : [schoolYearId, quarterId]],
        data
      )

      await queryClient.invalidateQueries({
        queryKey: ['expenditures']
      })

      return data
    }
  })
}
